import { ApiType } from "@gymflow/common";
import { LeadDTOItem, LeadPostDTO } from "@gymflow/types";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { reportQueryKeys } from "../report";
import { leadQueryKeys } from "./leadQueryKeys";

export function useLeadCreate(
  {
    api,
  }: {
    api: ApiType;
  },

  mutationOpts?: UseMutationOptions<LeadDTOItem, unknown, LeadPostDTO>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newLead) => {
      return (await api.leadApi.create(newLead)).data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: reportQueryKeys.lead() });
    },

    ...mutationOpts,
  });
}
